import cz from '../csCZ/navigation';

const en: typeof cz = {
	page_title: 'Digitální archiv',
	homepage: 'Home',
	search: 'Search',
	help: 'Help',
	contact: 'Contact',
	menu_icon_tooltip: 'Menu',
};

export default en;
